export default function($scope, context, $productOptionsElement){
    var product_left = '.halo-productView-left';
    var product_right = '.halo-productView-right';

    $('document').ready(function(){
        initProductMoreview($(product_left, $scope), $(product_right, $scope));

        $productOptionsElement.on('change', event => {
            const $changedOption = $(event.target);

            // Do not trigger an ajax request if it's a file or if the browser doesn't support FormData
            if ($changedOption.attr('type') === 'file' || window.FormData === undefined) {
                return;
            }

            initProductMoreview($(product_left, $scope), $(product_right, $scope), $changedOption );
        });
    });

    function initProductMoreview (productMoreview, productDetailview, $elementChange = false) {
        if ($('.halo-productView-default').length) {
            var sliderNav = productMoreview.find('.productView-images-wrapper'),
                sliderNavItem = sliderNav.find('.productView-image-item'),
                sliderNavMobile = productMoreview.find('.productView-nav-mobile');

            if(context.themeSettings.halo_variant_grouped === true) {
                var obj, myarray = context.themeSettings.halo_variant_name.split(",");
                var label = productDetailview.find('[data-product-option-change]').find('label[data-option-name]');
                var className = '', classN = '.filter-';

                label.each(function(i, el){
                    var str = $(el).data('option-name').toString();
                    
                    if($.inArray(str, myarray) !== -1) {
                        obj = $(el).parent('[data-product-attribute]');
                        
                        if(obj != undefined){
                            if(obj.data('product-attribute') == "set-select" ) {
                                var inputChecked = obj.find('select option:selected');
                            } else {
                                var inputChecked = obj.find(':radio:checked');
                            }
                            
                            if(inputChecked != undefined && inputChecked.length) {
                                var clsName = inputChecked.data('filter');

                                if(clsName != undefined && clsName.length) {
                                    clsName = clsName.replace('.filter-','');
                                    classN += clsName;
                                }
                            }
                        }
                    }
                });
                if(obj != undefined){
                    if(classN !== '.filter-') {
                        className = classN;

                        if(sliderNav.find(className).length == 0) {
                            for (var i = 0; i < myarray.length; i++) {
                                label.each(function(i, el){
                                    var str = $(el).data('option-name').toString();
                                    
                                    if($.inArray(str, myarray) !== -1) {
                                        obj = $(el).parent('[data-product-attribute]');
                                        
                                        if(obj != undefined){
                                            if(obj.data('product-attribute') == "set-select" ) {
                                                var inputChecked = obj.find('select option:selected');
                                            } else {
                                                var inputChecked = obj.find(':radio:checked');
                                            }
                                            
                                            if(inputChecked != undefined && inputChecked.length) {
                                                var clsName = inputChecked.data('filter');

                                                if(clsName != undefined && clsName.length) {
                                                    clsName = clsName.replace('.filter-','');
                                                    classN += clsName;
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        }

                        sliderNav.find(className).addClass('is-show').removeClass('is-hidden');
                        sliderNav.find('.productView-image-item:not('+ className +')').addClass('is-hidden').removeClass('is-show');
                        if($('.productView-show-image').length) {
                            sliderNav.find('.productView-show-image').hide();
                        }

                        if(sliderNavItem.hasClass('is-show')) {
                            var countImage = sliderNav.find('.is-show');

                            for (var i = 0; i < countImage.length; i++) {
                                countImage.eq(i).attr('data-index', i+1);
                                countImage.eq(i).find('.productView-image').attr('data-index', i+1);
                            }

                            if($('.halo-productVideos').length && $('.productView-image-item.is-show[data-index="1"]').length) {
                                $('.halo-productVideos').appendTo('.productView-image-item.is-show[data-index="1"]');
                            }
                        } else {
                           sliderNav.find('.productView-image-item').removeClass('is-hidden');

                            if($('.halo-productVideos').length && $('.productView-image-item[data-index="3"]').length) {
                                $('.halo-productVideos').appendTo('.productView-image-item[data-index="3"]');
                            }
                        }

                        sliderNavMobile.slick('slickUnfilter');

                        if(classN !== '.filter-') {
                            className = classN;

                            if(sliderNavMobile.find(className).length) {
                                var className2 = className.replace('.','');

                                sliderNavMobile.find('.productView-video').addClass(className2);
                                sliderNavMobile.slick('slickFilter', className);
                                sliderNavMobile.get(0).slick.setPosition();
                            }
                        }

                        if(sliderNavMobile.find('.slick-current').length) {
                            sliderNavMobile.slick('slickGoTo', 0);
                        }

                        sliderNavMobile.on('click', 'a', function(e){
                            const $target = $(e.currentTarget);
                            var slideno = sliderFor.find('.slick-slide').index( $target.parents('.slick-active'));

                            sliderNavMobile.slick('slickGoTo', slideno);
                            sliderNavMobile.find('.slick-slide').removeClass('slick-current');

                            $target.parents('.slick-active').addClass('slick-current');
                            return false;
                        });
                    }
                }
            }
        } else if ($('.halo-productView-custom').length) {
            var sliderFor = productMoreview.find('.productView-for'),
                sliderNav = productMoreview.find('.productView-nav:not(.productView-nav-mobile)'),
                sliderNavMobile = productMoreview.find('.productView-nav-mobile');

            if(context.themeSettings.halo_variant_grouped === true) {
                var obj, myarray = context.themeSettings.halo_variant_name.split(",");
                var label = productDetailview.find('[data-product-option-change]').find('label[data-option-name]');
                var className = '', classN = '.filter-';

                label.each(function(i, el){
                    var str = $(el).data('option-name').toString();
                    
                    if($.inArray(str, myarray) !== -1) {
                        obj = $(el).parent('[data-product-attribute]');
                        
                        if(obj != undefined){
                            if(obj.data('product-attribute') == "set-select" ) {
                                var inputChecked = obj.find('select option:selected');
                            } else {
                                var inputChecked = obj.find(':radio:checked');
                            }
                            
                            if(inputChecked != undefined && inputChecked.length) {
                                var clsName = inputChecked.data('filter');

                                if(clsName != undefined && clsName.length) {
                                    clsName = clsName.replace('.filter-','');
                                    classN += clsName;
                                }
                            }
                        }
                    }
                });

                if(obj != undefined){
                    sliderFor.slick('slickUnfilter');

                    if(classN !== '.filter-') {
                        className = classN;

                        if(sliderFor.find(className).length == 0) {
                            for (var i = 0; i < myarray.length; i++) {
                                label.each(function(i, el){
                                    var str = $(el).data('option-name').toString();
                                    
                                    if($.inArray(str, myarray) !== -1) {
                                        obj = $(el).parent('[data-product-attribute]');
                                        
                                        if(obj != undefined){
                                            if(obj.data('product-attribute') == "set-select" ) {
                                                var inputChecked = obj.find('select option:selected');
                                            } else {
                                                var inputChecked = obj.find(':radio:checked');
                                            }
                                            
                                            if(inputChecked != undefined && inputChecked.length) {
                                                var clsName = inputChecked.data('filter');

                                                if(clsName != undefined && clsName.length) {
                                                    clsName = clsName.replace('.filter-','');
                                                    classN += clsName;
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        }

                        if ($(window).width() > 550) {
                            if(sliderFor.find(className).length) {
                                var className2 = className.replace('.','');

                                sliderFor.find('.productView-thumbnail-video').addClass(className2);
                                sliderFor.slick('slickFilter', className)
                                sliderFor.get(0).slick.setPosition();
                            }

                            if(sliderNav.find(className).length) {
                                sliderNav.slick('slickFilter', className);
                                sliderNav.get(0).slick.setPosition();
                            }
                        }
                    }

                    if ($(window).width() > 550) {
                        if(sliderFor.find('.slick-current').length) {
                            sliderFor.slick('slickGoTo', 0);
                            sliderNav.slick('slickGoTo', 0);

                            sliderFor.find('.slick-current a').trigger('click');
                        }

                        sliderFor.on('click', 'a', function(e){
                            const $target = $(e.currentTarget);
                            var slideno = sliderFor.find('.slick-slide').index( $target.parents('.slick-active'));

                            sliderFor.slick('slickGoTo', slideno);
                            sliderNav.slick('slickGoTo', slideno);
                            sliderFor.find('.slick-slide').removeClass('slick-current');

                            $target.parents('.slick-active').addClass('slick-current');
                            return false;
                        });
                    }

                    sliderNavMobile.slick('slickUnfilter');

                    if(classN !== '.filter-') {
                        className = classN;

                        if(sliderNavMobile.find(className).length) {
                            var className2 = className.replace('.','');

                            sliderNavMobile.find('.productView-video').addClass(className2);
                            sliderNavMobile.slick('slickFilter', className);
                            sliderNavMobile.get(0).slick.setPosition();
                        }
                    }

                    if(sliderNavMobile.find('.slick-current').length) {
                        sliderNavMobile.slick('slickGoTo', 0);
                    }

                    sliderNavMobile.on('click', 'a', function(e){
                        const $target = $(e.currentTarget);
                        var slideno = sliderFor.find('.slick-slide').index( $target.parents('.slick-active'));

                        sliderNavMobile.slick('slickGoTo', slideno);
                        sliderNavMobile.find('.slick-slide').removeClass('slick-current');

                        $target.parents('.slick-active').addClass('slick-current');
                        return false;
                    });
                }
            }
        }
    }
}
